




































































import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";

const namespace = "customer";

@Component({})
export default class ModalPublishProduct extends Vue {
  @Prop(Object) readonly publish!: any;
  show = true;

 

  closeModal(): void {
    this.$emit("toogleModal");
  }

  publishProduct(): void {
    this.$emit("publishProduct");
  }
}
